// extracted by mini-css-extract-plugin
module.exports = {"container":"_103a151b99--container--CESQe","phone":"_103a151b99--phone--UaR0S","text":"_103a151b99--text--p3y7z","buttons":"_103a151b99--buttons--GrNTW"};